import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input, Injector} from '@angular/core';
import {fadeInAnimation, fadeInOut} from '../../../common/service/routerTransition';
import {TranslateService} from '@ngx-translate/core';
import { ModalBase } from '../../../common/components/modal.base.component';
import { DialogService } from '../../../common/service/dialog.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EventManagerService } from 'src/app/common/service/event-manager.service';
import { AppQueries } from 'src/app/state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomComponentService } from '../../services/custom-component.service';
@Component({
    selector: 'detail-agent',
    templateUrl: './detail-agent.html',
    animations: [fadeInAnimation, fadeInOut],
    host: {'[@fadeInAnimation]': ''}
  })
  
export class DetailAgent extends ModalBase implements OnInit {
    @Input('agent') agent;
    constructor(
        private translate: TranslateService,
        private eventManager: EventManagerService,
        private appQueries: AppQueries,
        public activeModal: NgbActiveModal,
        public sanitizer:DomSanitizer,
        public customComponentService: CustomComponentService,
        dialog: DialogService,
        injector: Injector) {
            super(injector)
    }
    ngOnInit() {
        !this.agent && ( this.agent = {})
    }
    cancel(modal) {
        this.agent = {};
        super.cancel(modal);
    }
    sanitize(url:string){
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
}